import { InspectionCase } from './inspection-case.dto';

export class InspectionPercentageCaseDto extends InspectionCase {
  value?: number; // %
}
export class InspectionPercentageCase extends InspectionPercentageCaseDto {
  constructor(data: InspectionPercentageCaseDto = {}) {
    super(data);
    this.value = data.value;
  }
}
